import { Block } from "../models/Block";
import { TextNode } from "../models/TextNode";
import { Modifier } from "../types";

enum Decorator {
	bold = "**",
	italic = "*",
	// strike = "~~"
}

function decoratorsDif(prev: Decorator[], current: Decorator[]) {
	const open = current.filter(decorator => !prev.includes(decorator));
	const close = prev.filter(decorator => !current.includes(decorator));
	return open.concat(close);
}

function serializeGroup(textNodes: TextNode[], link?: string) {
	let result = "";
	let prevDecorators = [];

	for (const textNode of textNodes) {
		const currentDecorators = [];
		const style = textNode.style;
		if (style[Modifier.bold]) {
			currentDecorators.push(Decorator.bold);
		}
		if (style[Modifier.italic]) {
			currentDecorators.push(Decorator.italic);
		}
		const dif = decoratorsDif(prevDecorators, currentDecorators);
		if (!prevDecorators.length && currentDecorators.length) {
			result += " ";
		}
		result += dif.join("");

		if (prevDecorators.length && !currentDecorators.length) {
			result += " ";
		}
		result += textNode.text.trim();

		prevDecorators = currentDecorators;
	}
	result += prevDecorators.join("");
	if (link) {
		result = `[${result}](${link})`;
	}
	return result.trim();
}

function serializeBlockContent(block: Block) {
	let result = "";

	const textNodes = block.textNodes;

	let group = [];
	let currentLink;

	for (const textNode of textNodes) {
		if (textNode.style.link) {
			if (currentLink === textNode.style.link) {
				group.push(textNode);
			} else {
				if (group.length) {
					result += serializeGroup(group, currentLink);
				}
				group = [textNode];
			}
		} else {
			if (currentLink) {
				if (group.length) {
					result += serializeGroup(group, currentLink);
				}
				group = [textNode];
			} else {
				group.push(textNode);
			}
		}
		currentLink = textNode.style.link;
	}

	result += serializeGroup(group, currentLink);

	return result;
}

function blockPrefix(block) {
	switch (block.style[Modifier.style]) {
		case "h1":
			return "# ";
		case "h2":
			return "## ";
		case "h3":
			return "### ";
		case "h4":
			return "#### ";
		case "h5":
			return "##### ";
		case "h6":
			return "###### ";
		default:
			return "";
	}
}

export function markdownSerializer(blocks: Block[]) {
	return blocks.reduce(
		(res, block, i) => res + (i ? "\n\n" : "") + blockPrefix(block) + serializeBlockContent(block),
		""
	);
}
